import { render, staticRenderFns } from "./AssetsUpdate.vue?vue&type=template&id=bb62a050&scoped=true"
import script from "./AssetsUpdate.vue?vue&type=script&lang=js"
export * from "./AssetsUpdate.vue?vue&type=script&lang=js"
import style0 from "./AssetsUpdate.vue?vue&type=style&index=0&id=bb62a050&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb62a050",
  null
  
)

export default component.exports